import { createFileRoute, useNavigate } from "@tanstack/react-router";
import JobSearch from "@/features/job-post/search/job-search";
import { z } from "zod";

export const Route = createFileRoute("/_provider/provider/jobs/search/")({
  validateSearch: z.object({
    specialtyIds: z.string().optional(),
    professionalTypeId: z.string().optional(),
    minSalary: z.string().optional(),
    showRejected: z.string().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const searchParams = Route.useSearch();
  const navigate = useNavigate();
  return (
    <JobSearch
      searchParams={searchParams}
      onSearchParamsChange={(newSearchParams) => {
        navigate({
          to: "/provider/jobs/search",
          search: newSearchParams,
        });
      }}
    />
  );
}
